import {Command} from "../command";
import {CommandType} from "../commandType";
import {EstimateRowType} from "../state/estimateRowType";
import {EditorMode, EstimateCostRowPopupParams} from "../../components/estimate-cost-row-popup/estimate-cost-row-popup";
import * as $ from "jquery";
import {PopupType} from "../popups/popupType";
import {PopupMode} from "../popups/popup";
import {Application} from "../application";
import * as ko from "knockout";
import { EstimateRow } from "../state/estimateRow";
import * as _ from "lodash";

export class EditEstimateCostRowCommand implements Command {
    constructor(private app: Application) {

    }

    type: CommandType = CommandType.EditEstimateCostRow;
    canExecute = ko.computed(() => {

        let estimate = this.app.state.estimate();

        if (!estimate)
            return false;

        if (estimate.selectedRow().length == 0)
            return false;


        let row = estimate.selectedRow()[0];


        if (!row)
            return false;

        return row.type == EstimateRowType.cost;
    });
    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });
    execute(data: { editorMode: EditorMode }): JQueryPromise<any> {
        if (!this.canExecute())
            return $.Deferred().reject().promise();

        let selectedRow = _.last<EstimateRow>(this.app.state.estimate()!.selectedRow());
        if (selectedRow)
            this.app.state.estimate()!.baseRow(selectedRow);
        else
            this.app.state.estimate()!.baseRow(null);

        return this.app.popupsManager.show<EstimateCostRowPopupParams>(PopupType.estimateCostRow, false,<EstimateCostRowPopupParams>{
            popupMode: PopupMode.Edit,
            editorMode: data.editorMode
        });
    }

    name = "Edit Subtotal Row";
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/editEstimateCostRowCommand.ts